import React from 'react';
import { Helmet } from 'react-helmet-async';
import TaskManager from './TaskManager';

const TasksPage = () => {
  return (
    <div className="py-6">
      <Helmet>
        <title>Tasks | FrameWorX</title>
      </Helmet>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 className="text-2xl font-semibold text-gray-100">Tasks</h1>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <div className="py-4">
          <TaskManager />
        </div>
      </div>
    </div>
  );
};

export default TasksPage; 